import { sendActionLog } from '../sendActionLog'

export const PAGE_ID = '/picka_home'

export const homeActionLog = {
  inital: async () => {
    await sendActionLog({
      pageId: PAGE_ID,
    })
  },
  clickMenu: async () => {
    await sendActionLog({
      pageId: PAGE_ID,
      actionId: 'click_menu',
    })
  },
  clickPurchase: async ({ purchaseCount, free }: { purchaseCount: number; free?: boolean }) => {
    await sendActionLog({
      pageId: PAGE_ID,
      actionId: 'click_purchase',
      body: {
        status: free ? 'free' : purchaseCount,
      },
    })
  },
}
